import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFab from "@/components/WhatsAppFab";
import Home from "@/pages/Home";
import Register from "@/pages/Register";
import GirlsWinterPage from "@/pages/GirlsWinterPage";
import Admin from "@/pages/Admin";
import { loadRemoteContent } from "@/lib/contentLoader";

function App() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    loadRemoteContent().finally(() => setReady(true));
  }, []);

  if (!ready) {
    return (
      <div className="min-h-screen bg-night flex items-center justify-center" data-testid="app-loading">
        <img src="/assets/asa-logo.jpeg" alt="ASA" className="w-20 h-20 rounded-full object-cover animate-pulse ring-2 ring-brand-gold/40" />
      </div>
    );
  }

  return (
    <div className="App">
      <ReactLenis root options={{ lerp: 0.09, wheelMultiplier: 1 }}>
        <BrowserRouter>
          <Routes>
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={
              <>
                <Navbar />
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/girls-winter" element={<GirlsWinterPage />} />
                </Routes>
                <Footer />
                <WhatsAppFab />
              </>
            } />
          </Routes>
          <Toaster theme="dark" position="top-center" richColors />
        </BrowserRouter>
      </ReactLenis>
    </div>
  );
}

export default App;
